import { Flex, Text } from '@chakra-ui/react';
import CompaniesService from 'api/services/CompaniesService';
import CompaniesSettingsService from 'api/services/CompaniesSettingsService';
import CardMy from 'components/CardMy';
import BigTitle from 'components/CardMy/BigTitle';
import InputMy from 'components/InputMy';
import Loader from 'components/Loader';
import UpdateCancel from 'components/UpdateCancel';
import _ from 'lodash';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
    FilteredKpis,
    fetchKpis,
    selectKpisArray,
    selectKpisIsLoading,
    selectKpisObject,
} from 'store/slices/companySetting';
import { fetchMe, selectMe } from 'store/slices/user';
import Row from './Row';

const Card1 = () => {
    const { company } = useAppSelector(selectMe);
    const dispatch = useAppDispatch();
    const title = company?.name;
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(title);

    const disabled = value === title;

    const handleCancel = () => setValue(title);
    const handleSave = async () => {
        try {
            setLoading(true);
            await CompaniesService.update({ companyId: company.id, name: value })
                .then(() => {
                    showMessage('updated');
                    dispatch(fetchMe());
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {}
    };

    return (
        <CardMy>
            <Flex flexDirection="column" gap="24px">
                <BigTitle>General</BigTitle>
                <InputMy
                    sx={{ maxWidth: '500px' }}
                    label="Company Name"
                    placeholder="Enter name"
                    value={value}
                    onChangeValue={setValue}
                />
                <UpdateCancel disabled={disabled} loading={loading} onCancel={handleCancel} onSave={handleSave} />
            </Flex>
        </CardMy>
    );
};

const Card2 = () => {
    const dispatch = useAppDispatch();
    const { company } = useAppSelector(selectMe);
    const kpisArray = useAppSelector(selectKpisArray);
    const kpisObject = useAppSelector(selectKpisObject);
    const kpisIsLoading = useAppSelector(selectKpisIsLoading);

    const [values, setValues] = useState<FilteredKpis>(kpisObject);
    const [loading, setLoading] = useState(false);

    const handleCancel = () => setValues(kpisObject);

    const handleSave = async () => {
        try {
            setLoading(true);
            await CompaniesSettingsService.kpisUpdate({ companyId: company.id, ...values })
                .then(() => {
                    showMessage('updated');
                    dispatch(fetchKpis());
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {}
    };

    useEffect(() => {
        setValues(kpisObject);
    }, [kpisIsLoading]);

    const disabled = _.isEqual(kpisObject, values);

    return (
        <CardMy>
            <Flex flexDirection="column" gap="24px">
                <BigTitle>Heading</BigTitle>
                <Flex maxWidth="500px" flexDirection="column" gap="16px">
                    <Row>
                        <Text fontSize="16px" fontWeight={700} color="gray.900">
                            Diagnosis
                        </Text>
                        <Text fontSize="16px" fontWeight={700} color="gray.900">
                            KPI
                        </Text>
                    </Row>
                    {kpisIsLoading ? (
                        <Loader />
                    ) : (
                        kpisArray.map(item => (
                            <Row key={item.name}>
                                <Text fontSize="16px" fontWeight={400} color="gray.900">
                                    {item.name}
                                </Text>
                                <InputMy
                                    value={values[item.name] || ''}
                                    onChangeValue={value => {
                                        setValues({ ...values, [item.name]: Number(value) });
                                    }}
                                />
                            </Row>
                        ))
                    )}
                </Flex>
                <UpdateCancel disabled={disabled} loading={loading} onCancel={handleCancel} onSave={handleSave} />
            </Flex>
        </CardMy>
    );
};

const General = () => {
    return (
        <Flex flexDirection="column" gap="8px">
            <Card1 />
            <Card2 />
        </Flex>
    );
};

export default General;
